<div class="cal_container" *ngIf="!enabled || headerEnabled || selected ==
    undefined" (click)="enabled= true; openCalendar(); valSel()">
    <span>{{filterName}}</span>
</div>
<!--  [@openClose]="(enabled && selected !== undefined) ? 'open' : 'closed'" -->
<div class="row" [class.w-100]="fullwidth" style="cursor: pointer;" *ngIf="enabled" [ngClass]="{'hide': selected == undefined}" (click)="openCalendar()">
    <input type="text" readonly="true" [alwaysShowCalendars]="false" ngxDaterangepickerMd [locale]='days' [autoApply]="true" [disabled]="disabled"
           [ngClass]="{'disabled': disabled}" (change)="selectedDate($event); firstRun = false" [(ngModel)]="selected" [value]="chosenLabel" />
    <svg-icon style="cursor: pointer; " src="../../../assets/svg/close.svg " (click)="reset()"></svg-icon>
</div>